// extracted by mini-css-extract-plugin
export default {"label":"UCC_label__w45tn","data":"UCC_data__tn8Ia","feeContainer":"UCC_feeContainer__ANs2n"};